import Routes from 'Routes';
import { clearFlight, restFlight, initFlight } from './modules/actions';
import { saveOldLocation } from '../../modules/actions';
import { isEqual } from 'lodash/lang';
import { saveChangeProcess } from '../endorsedApply/modules/actions';
import { loadStatusCodeMsg } from 'enEXchange';
import { compare } from 'Utils';
import { gspCollect, isCsairApp, gspNewVersion } from '@csair/emp-helpers';
export default store => ({
  path: Routes.ticket.child.ticketChange.key,
  onEnter(nextState, replace, callback) {
    loadStatusCodeMsg(['afterSaleChangeReqNewFlightDetail']);
    gspNewVersion(
      ['变更-选择新航班页面-选择新航班页面', '072-0021-23028-12201'],
      {
        1: '页面曝光一次触发一次',
        2: '国双新版',
        3: isCsairApp() ? 'App' : 'Mobile',
      }
    );
    window.sessionStorage.removeItem('pageButtonName');
    const {
      App: { oldLocation },
      EdorsedApply: { changeProcess, flightList, psgList },
    } = store.getState();
    window.sessionStorage.removeItem('upCharge');
    window.sessionStorage.removeItem('licheng');
    const flightArr = nextState.location.query.flight.split(',').sort(compare);
    const personArr = nextState.location.query.person.split(',').sort(compare);

    let originSelectFlight = flightList.filter(
      (item, i) => flightArr.indexOf(String(i)) !== -1
    );
    let originSelectpsg = psgList.filter(
      (item, i) => personArr.indexOf(String(i)) !== -1
    );
    window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
      page_name: '机票退改-变更新航班页',
      channel_id: nextState.location.query.channel
        ? nextState.location.query.channel
        : '',
      ticket_number: originSelectpsg.map(obj => obj.ticketNo).join(';'),
      flight_date: originSelectFlight.map(obj => obj.flightDate).join(';'),
      flight_number: originSelectFlight.map(obj => obj.flightNo).join(';'),
      origin_location: originSelectFlight
        .map(obj => obj.depAirportName)
        .join(';'),
      destination_location: originSelectFlight
        .map(obj => obj.arrAirportName)
        .join(';'),
      passenger_type: originSelectpsg
        .map(obj =>
          obj.psgType === 3
            ? '婴儿'
            : obj.psgType === 1 || obj.psgType === 2
            ? '儿童'
            : '成人'
        )
        .join(';'),
      ticket_refund_type:
        changeProcess && changeProcess[0] && changeProcess[0] === 'zybg'
          ? '自愿变更'
          : '非自愿变更',
    });

    // 提交页面 -> 选择新航班页面时要返回选择乘机人页面
    if (oldLocation.pathname === Routes.ticket.child.applySubmit.path) {
      // window.history.go(-2);
      // return false;
      store.dispatch(clearFlight());
    }

    // resetDateKey重选功能 选择日期页面 -> 选择新航班页面
    if (!oldLocation.query.resetDateKey) {
      if (!nextState.location.query.changeKey) {
        store.dispatch(clearFlight());
        if (
          !isEqual(
            Array.isArray(changeProcess)
              ? changeProcess.sort()
              : [changeProcess],
            Array.isArray(nextState.location.query.changeProcess)
              ? nextState.location.query.changeProcess.sort()
              : [nextState.location.query.changeProcess]
          )
        ) {
          store.dispatch(
            saveChangeProcess({
              changeProcess: Array.isArray(
                nextState.location.query.changeProcess
              )
                ? nextState.location.query.changeProcess.sort()
                : [nextState.location.query.changeProcess],
            })
          );
        }
      } else {
        store.dispatch(restFlight(Number(nextState.location.query.changeKey)));
      }
    }

    callback();
  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const TicketChange = require('./components/TicketChangesItem').default;
        cb(null, TicketChange);
      },
      'ticketChange'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/ticketChanges/index.js